const LOGO_URL = "/logo.png";

export const Footer = () => {
  return (
    <footer className="border-t border-[#2A2A2A]/30 py-16 px-6 md:px-12 bg-[#0A0A0A]" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img src={LOGO_URL} alt="Paysagement multi-concepts" className="h-14 w-auto object-contain mb-4" />
            <p className="font-sans text-sm text-[#A1A1AA] leading-relaxed max-w-xs">
              L'excellence extérieure, pensée dans les moindres détails. Aménagements paysagers haut de gamme à Montcalm, Québec.
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="font-sans text-xs uppercase tracking-[0.2em] text-[#E8891C] mb-5">Navigation</p>
            <div className="space-y-3">
              {["Services", "Réalisations", "Témoignages"].map((link) => (
                <button
                  key={link}
                  onClick={() => document.getElementById(link.toLowerCase() === "réalisations" ? "portfolio" : link.toLowerCase() === "témoignages" ? "testimonials" : link.toLowerCase())?.scrollIntoView({ behavior: "smooth" })}
                  className="block font-sans text-sm text-[#A1A1AA] hover:text-[#E8891C] transition-colors duration-300"
                >
                  {link}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="font-sans text-xs uppercase tracking-[0.2em] text-[#E8891C] mb-5">Contact</p>
            <div className="space-y-3">
              <a href="tel:5148094242" className="block font-sans text-sm text-[#A1A1AA] hover:text-[#E8891C] transition-colors duration-300">(514) 809-4242</a>
              <p className="font-sans text-sm text-[#A1A1AA]">76 Rue Principale<br />Montcalm, Québec</p>
            </div>
          </div>
        </div>

        <div className="gold-line mb-8"></div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-sans text-xs text-[#A1A1AA]/60">
            &copy; {new Date().getFullYear()} Paysagement multi-concepts. Tous droits réservés.
          </p>
          <a href="/admin/login" className="font-sans text-xs text-[#A1A1AA]/30 hover:text-[#A1A1AA]/60 transition-colors duration-300">
            Administration
          </a>
        </div>
      </div>
    </footer>
  );
};
